<template>
  <div
    v-if="applicationReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          v-if="!formSubmitted"
          cols="12"
        >
          <b-row>
            <b-col
              cols="12"
              class="question question-margin-bottom"
            >
              <h1>
                Set Visitor Type
              </h1>
            </b-col>
          </b-row>

          <b-row
            v-if="currentPage === 1 && $v.formAnswers.pageOne.$error"
            class="question-errors"
          >
            <b-col
              cols="12"
              class="pb-3"
            >
              <div
                v-if="!$v.formAnswers.pageOne.visitorType.required"
                class="invalid-feedback"
              >
                <h3>Visitor type is required</h3>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <smooth-reflow>
                <b-form @submit.prevent>
                  <b-row>
                    <b-col cols="12">
                      <b-form-row class="question-answer">
                        <b-col
                          cols="12"
                          md="6"
                          class="pb-3"
                          offset-md="3"
                        >
                          <b-form-select
                            size="lg"
                            v-model="formAnswers.pageOne.visitorType"
                            :options="[
                              { value: null, text: 'Visitor Type '},
                              { value: 8, text: 'Family/friend' },
                              { value: 1, text: 'MD/DPM/NP/PA/OD' },
                              { value: 2, text: 'Home Health' },
                              { value: 3, text: 'Hospice' },
                              { value: 4, text: 'PT/OT/ST – Part B only' },
                              { value: 5, text: 'Agency Staff' },
                              { value: 6, text: 'Private Duty Caregiver' },
                              { value: 7, text: 'Other' }
                            ]"
                          />
                          <!-- :state="isMissing($v.formAnswers.pageOne.phone.$error)" -->
                        </b-col>
                      </b-form-row>
                    </b-col>
                  </b-row>
                </b-form>
              </smooth-reflow>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="canGoForward"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="nextPage"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-right-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="!canGoForward && !formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click="nextPage"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { between, decimal, required } from 'vuelidate/lib/validators'
import { required } from 'vuelidate/lib/validators'

export default {
  middleware: 'auth',
  name: 'FirstTimeVisitor',
  components: {
    'smooth-reflow': () => import(/* webpackPrefetch: true */ /* webpackChunkName: "smooth-reflow" */ '../components/SmoothReflow')
  },
  data () {
    return {
      currentPage: 1,
      formSubmitted: false,
      states: [
        {
          value: 'disabled',
          text: 'State',
          disabled: true
        }
      ],
      formAnswers: {
        pageOne: {
          visitorType: null
        }
      }
    }
  },
  validations: {
    formAnswers: {
      pageOne: {
        visitorType: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'applicationReady',
      'selectedUser'
    ]),
    ...mapGetters({
      masks: 'forms/masks',
      allBfmsWithBranchUsers: 'branchUsers/allBfmsWithBranchUsers'
    }),
    canGoBack () {
      return this.currentPage === 1
    },
    canGoForward () {
      if (this.collectAddress) {
        return this.currentPage < 2
      }
      return false
    },
    collectAddress () {
      return (this.userState === 'OH' || this.userState === 'PA')
    }
  },
  methods: {
    ...mapActions([
      'setVisitorTypeInformation',
      'setSelectedUser'
    ]),
    ...mapActions({
      replaceBfm: 'branchUsers/replaceBfm',
      cacheBranchUsers: 'branchUsers/cacheBranchUsers'
    }),
    nextPage () {
      this.$v.formAnswers.pageOne.$touch()
      if (!this.$v.formAnswers.pageOne.$invalid) {
        this.submitForm()
      }
    },
    previousPage () {
      // Go back to the "Who are you screening" page
    },
    submitForm () {
      // Submit our form go to screening select page and add the user to be submitted to thing.
      const selectedUser = this.selectedUser
      selectedUser.visitorType = this.formAnswers.pageOne.visitorType
      console.log('Visitor Type Information')
      console.log(selectedUser)
      // Replace selected user in AllBfms with SelectedUser with type
      this.replaceBfm(selectedUser)

      this.cacheBranchUsers()
      this.setVisitorTypeInformation(selectedUser)

      if (this.isSelfMode) {
        this.$router.push({ name: 'visitor-guidelines' })
      } else {
        this.$router.push({ name: 'available-forms' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-bottom {
  text-align: center;
}
</style>
